import { handleApiCall } from "../api";

export const Login = (postPayload: any) =>
  handleApiCall("post", "/auth/user-login", postPayload);

/** Mobile OTP login: POST /auth/login/otp with phone_number and otp */
export const loginWithOtp = (payload: { phone_number: string; otp: string }) =>
  handleApiCall("post", "/auth/login/otp", payload);

/** Email OTP login: POST /auth/login/otp with email and otp */
export const loginWithEmailOtp = (payload: { email: string; otp: string }) =>
  handleApiCall("post", "/auth/login/otp", payload);

export const refreshLogin =(postPayload)=>handleApiCall("post", "/auth/refresh-token", postPayload);

export const forgotPassword = (postPayload) => handleApiCall("post","/auth/forgot-password",postPayload);

export const resetPassword = (postPayLoad) => handleApiCall("post","/auth/reset-password",postPayLoad);

export const createRegistration = (postPayoad) => handleApiCall("post","/users/user-register",postPayoad);

export const changePassword = (postPayload) => handleApiCall("post",'/users/auth/change-password',postPayload);

export const validateResetToken = (token) => handleApiCall('get',`/auth/validate-token?token=${token}`);

export const sendOtp = (payload: any) => handleApiCall("post", "/otp/send", payload);

export const verifyOtp = (payload: any) => handleApiCall("post", "/otp/verify", payload);